import tosEnglish from "@/components/tos/tos_en.txt?raw";
import tosHebrew from "@/components/tos/tos_he.txt?raw";

/**
 * Get Terms of Service text based on language
 * @param language - Language code ('en' or 'he')
 * @returns ToS text content
 */
export const getTosText = (language: 'en' | 'he'): string => {
  return language === 'he' ? tosHebrew : tosEnglish;
};

/**
 * Get both English and Hebrew ToS texts
 * @returns Object with both language texts
 */
export const getAllTosTexts = (): { en: string; he: string } => {
  return {
    en: tosEnglish,
    he: tosHebrew,
  };
};
